import { DataType } from "shared/types";

import OverflowingColumnCell from "features/ui/MaterialTable/components/OverflowingColumnCell";

import HeaderText from "./HeaderText";
import {
  ColumnCellRenderProps,
  ColumnHeaderRenderProps,
  SmartGroupColumnDefinition,
  SmartGroupColumnId,
} from "./types";

export const groupNameColumn: SmartGroupColumnDefinition = {
  id: SmartGroupColumnId.GROUP_NAME,

  getSchema: () => ({
    accessor: "groupName",
    label: "",
    dataType: DataType.STRING,
    columnWidth: 300,
  }),

  renderHeader: ({ context }: ColumnHeaderRenderProps) => (
    <HeaderText text={context.t("schema:dashboard.group_name")} />
  ),

  renderCell: ({ row }: ColumnCellRenderProps) => (
    <OverflowingColumnCell value={row.groupName} />
  ),
};
